export default __webpack_public_path__ + "static/19-9c47771e2b60cbd4172a37c9acb837a4.jpg";